import React from 'react';
import { Stack } from '../Stack/Stack';
import { PieChart } from '../Charts/PieChart';
import GlobalProps from '../globalProps';
import { formatPercentage } from '../../util/formatters';
import { ProgressBar } from '../ProgressBar/ProgressBar';
import './DonutWithBars.css';
import { sum } from 'lodash';

interface Props extends GlobalProps {
  data: Segment[];
  maximumFractionDigits?: number;
}

export interface Segment {
  name: string;
  value: number;
  color?: string;
}

export function DonutWithBars({ data, maximumFractionDigits = 2 }: Props): JSX.Element {
  const total = sum(data.map((segment) => segment.value));

  return (
    <Stack line justify="center" size="xxxl">
      <PieChart data={data} className="donut-with-bars__pie-chart" sortedClockwise />
      <div className="donut-with-bars__legends">
        <Stack size="lg" justify="left">
          {data.map((segment) => (
            <div key={segment.name} className="donut-with-bars__legend">
              <Stack size="16">
                <Stack line justify="space-between" size="xs">
                  <p className="donut-with-bars__legend-name">{segment.name}</p>
                  <p>{formatPercentage((segment.value * 1.0) / total, { maximumFractionDigits })}</p>
                </Stack>
                <ProgressBar
                  progress={(segment.value * 1.0) / total}
                  size="big"
                  baseColor="var(--color-ticket-unknown)"
                  barColor={segment.color}
                  rounded
                />
              </Stack>
            </div>
          ))}
        </Stack>
      </div>
    </Stack>
  );
}
